<!-- Loading and error -->
<app-loading-status *ngIf="loaderService.isLoading | async; else notLoading"></app-loading-status>
<app-alert-status *ngIf="loadingError" [loadingError]="loadingError"></app-alert-status>

<ng-template #notLoading>
  <ng-container *ngIf="{ darkMode: darkMode$ | async } as ui">
    <div class="container-fluid">
      <div class="row justify-content-center pt-5">
        <div class="col-md-11 col-12">

          <!-- Heading and search -->
          <div class="row align-items-end mt-5 mb-4">
            <div class="col-lg-6 col-12">
              <app-area-heading [heading]="layout.heading" [subheading]="layout.subheading"
                [backRoute]="layout.backRoute"></app-area-heading>
            </div>

            <div class="col-lg-6 col-12 d-flex justify-content-lg-end mt-3 mt-lg-0">
              <div class="input-group tool-search">
                <div class="input-group-prepend">
                  <span class="input-group-text" [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}">
                    <i class="far fa-search"></i>
                  </span>
                </div>
                <input type="text" class="form-control" placeholder="Search tools" aria-label="Search tools"
                  [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}"
                  [(ngModel)]="searchTerm" (ngModelChange)="applySearch()">
                <div class="input-group-append" *ngIf="searchTerm">
                  <button class="btn btn-outline-secondary" type="button" (click)="clearSearch()" aria-label="Clear search">
                    <i class="far fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Result count -->
          <div class="mb-3 text-secondary" [class.text-light]="ui.darkMode">
            Showing {{ filteredTools.length }} of {{ toolInformation.length }} tools
          </div>

          <!-- Tool cards -->
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6 col-12 mb-4 d-flex align-items-stretch"
              *ngFor="let tool of filteredTools; trackBy: trackByTitle">

              <!-- Links out to SharePoint -->
              <a *ngIf="isExternal(tool)" class="card tool-card w-100" [href]="tool.folderLocationLink"
                target="_blank" rel="noopener" [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}">
                <ng-container *ngTemplateOutlet="cardBody; context: { tool: tool, ui: ui }"></ng-container>
              </a>

              <!-- Opens in the admin tool, or is not ready yet -->
              <div *ngIf="!isExternal(tool)" class="card tool-card w-100"
                [class.tool-card-disabled]="!isAvailable(tool)"
                [ngClass]="{'bg-dark-700 text-light border-dark': ui.darkMode}"
                [attr.role]="isAvailable(tool) ? 'button' : null"
                [attr.tabindex]="isAvailable(tool) ? 0 : null"
                [attr.aria-disabled]="isAvailable(tool) ? null : 'true'"
                (click)="openTool(tool)" (keydown.enter)="openTool(tool)" (keydown.space)="openTool(tool)">
                <ng-container *ngTemplateOutlet="cardBody; context: { tool: tool, ui: ui }"></ng-container>
              </div>

            </div>
          </div>

          <!-- No search results -->
          <div class="text-center py-5" *ngIf="!filteredTools.length">
            <i class="far fa-search fa-2x mb-3" [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}"></i>
            <div [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}">
              No tools match "{{ searchTerm }}".
            </div>
            <button class="btn btn-link" (click)="clearSearch()">Clear search</button>
          </div>

        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<!-- Shared card contents -->
<ng-template #cardBody let-tool="tool" let-ui="ui">
  <!-- Icon sits behind the content as a watermark in the bottom right corner -->
  <i [class]="tool.icon" class="tool-watermark" [ngClass]="{'tool-watermark-dark': ui.darkMode}"
    aria-hidden="true"></i>

  <div class="card-body d-flex flex-column position-relative">
    <div class="d-flex justify-content-between align-items-start mb-3">
      <span class="badge tool-status" [ngClass]="statusBadgeClass(tool, ui.darkMode)">
        {{ toolStatus(tool) }}
      </span>
      <i class="tool-chevron" *ngIf="isAvailable(tool) || isExternal(tool)"
        [ngClass]="[
          isExternal(tool) ? 'far fa-external-link' : 'far fa-angle-right',
          ui.darkMode ? 'text-light' : 'text-secondary'
        ]"></i>
    </div>

    <h5 class="card-title tool-name mb-0" [ngClass]="{'text-light': ui.darkMode}">{{ tool.title }}</h5>

    <p class="card-text small mt-auto pt-3 mb-0" [ngClass]="{'text-light': ui.darkMode, 'text-secondary': !ui.darkMode}">
      {{ tool.subTitle }}
    </p>
  </div>
</ng-template>
